(function () {
  var TEXT_REPLACEMENTS = {
    'Reviews': 'Opinie',
    'Review': 'Opinia',
    'Write a Review': 'Napisz opinię',
    'Write A Review': 'Napisz opinię',
    'No reviews yet, write one now?': 'Brak opinii. Napisz pierwszą opinię.',
    'No Reviews Yet': 'Brak opinii',
    'Be the first to write a review': 'Napisz pierwszą opinię',
    'Based on 0 reviews': 'Na podstawie 0 opinii',
    'Read Reviews': 'Czytaj opinie'
  };

  var ATTRS = ['aria-label', 'title', 'data-label'];

  function translateString(value) {
    if (!value) return value;

    var trimmed = value.trim();
    var replacement = TEXT_REPLACEMENTS[trimmed];
    if (!replacement) return value;

    return value.replace(trimmed, replacement);
  }

  function shouldTranslateNode(node) {
    if (!node || !node.parentElement) return false;

    return Boolean(node.parentElement.closest(
      '[data-oke-widget], [data-oke-star-rating], [class*="okeReviews"], [class*="oke-"], [class*="Okendo"]'
    ));
  }

  function translateTextNodes(root) {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      if (shouldTranslateNode(root)) {
        root.nodeValue = translateString(root.nodeValue);
      }
      return;
    }

    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;

    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) {
      if (shouldTranslateNode(node)) {
        node.nodeValue = translateString(node.nodeValue);
      }
    }
  }

  function translateAttrs(root) {
    if (!root || root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;

    var elements = root.querySelectorAll
      ? root.querySelectorAll('[data-oke-widget], [data-oke-widget] *, [data-oke-star-rating], [data-oke-star-rating] *, [class*="okeReviews"], [class*="okeReviews"] *, [class*="oke-"], [class*="oke-"] *')
      : [];

    elements.forEach(function (el) {
      ATTRS.forEach(function (attr) {
        if (el.hasAttribute(attr)) {
          el.setAttribute(attr, translateString(el.getAttribute(attr)));
        }
      });
    });
  }

  function translateOkendo(root) {
    translateTextNodes(root || document.body);
    translateAttrs(root || document);
  }

  function init() {
    translateOkendo(document.body);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          translateOkendo(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
